export default defineNuxtPlugin(() => {})
